export default defineNuxtPlugin(() => {})
